export default __webpack_public_path__ + "static/media/tpa-facebook.a34c7083.png";